module.exports = __webpack_public_path__ + "img/Qualification_1.b59ac9b1.jpg";